import { gql } from "@apollo/client";

export const GQL_ALL_PROVINCES = gql`
   query allProvinces {
      allProvinces {
         id
         code
         description
      }
   }
`;

export const GQL_REGIONI = gql`
   query regioni {
      regioni {
         id
         name
      }
   }
`;

export const GQL_COMUNI = gql`
   query comuni($filter: ComuneFilterInput) {
      comuni(filter: $filter) {
         data {
            id
            code
            description
            province {
               id
               code
            }
         }
         paginatorInfo {
            total
            currentPage
            perPage
         }
      }
   }
`;

export const LOCATION_TAX_ACCOUNTS = gql`
   query locationTaxAccounts {
      locationTaxAccounts {
         id
         description
         latitude
         longitude
      }
   }
`;

export const LOCATION_DOSSIERS = gql`
   query locationDossiers {
      locationDossiers {
         id
         description
         latitude
         longitude
      }
   }
`;

export const LOCATION_PRIVATE_TAX_PROVIDERS = gql`
   query locationPrivateTaxProviders {
      locationPrivateTaxProviders {
         id
         company_name
         place
         prov_code
         latitude
         longitude
      }
   }
`;
